import { useMapEvent } from 'react-leaflet';

const MapClickHandler = ({ address }) => {
    useMapEvent('click', () => {
        window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
    });

    return null;
};

export default MapClickHandler;
